import * as S from './style';

interface FieldProps {
	title?: string;
	error?: string;
	children: React.ReactNode;
	gap?: string;
}
const Field = ({ title, error, children, gap = '0.4rem' }: FieldProps) => (
	<S.Container gap={gap} error={!!error}>
		{title && <S.Label>{title}</S.Label>}

		{children}
		{error && <S.ErrorMsg>{error}</S.ErrorMsg>}
	</S.Container>
);
export default Field;
